var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 2.5H6C3.79086 2.5 2 4.29086 2 6.5V18.5C2 20.7091 3.79086 22.5 6 22.5H18C20.2091 22.5 22 20.7091 22 18.5V6.5C22 4.29086 20.2091 2.5 18 2.5ZM6 0.5C2.68629 0.5 0 3.18629 0 6.5V18.5C0 21.8137 2.68629 24.5 6 24.5H18C21.3137 24.5 24 21.8137 24 18.5V6.5C24 3.18629 21.3137 0.5 18 0.5H6ZM8 9.5V19.5H6V9.5H8ZM12 10.2578V9.5H10V14V17.5V19.5H12V17.5V14C12 12.6193 13.1193 11.5 14.5 11.5C15.8807 11.5 17 12.6193 17 14V19.5H19V14C19 11.5147 16.9853 9.5 14.5 9.5C13.5749 9.5 12.715 9.77914 12 10.2578ZM8.5 6.5C8.5 7.32843 7.82843 8 7 8C6.17157 8 5.5 7.32843 5.5 6.5C5.5 5.67157 6.17157 5 7 5C7.82843 5 8.5 5.67157 8.5 6.5Z",
    fill: "#000408"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4e22cfc62b03e947c542b0e82ff091e1.svg";
export { ForwardRef as ReactComponent };